import React, { useEffect } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { Dispatch } from 'redux';
import moment from 'moment';
import SealLogsView from './SealLogsView';
import { commonUtils } from 'redux/_common';
import { inspectorSelectors } from 'redux/app/vessel/inspector';
import { IStore } from 'redux/store';
import { useParams } from 'react-router-dom';
import Frame from 'react-frame-component';
import { getInitialContent } from 'redux/app/vessel/inspector/utils';
import { vesselActions } from 'redux/app/vessel';

type OwnProps = {
    iframeRef: any;
    bookId: string;
};
type SealLogsInspectorViewProps = PropsFromRedux & OwnProps;

const timeNow = moment().format('DD/MM/YYYY HH:mm');

function SealLogsInspectorView(props: SealLogsInspectorViewProps) {
    const { iframeRef, bookId, showCoverPages, stateOfScriptInjection } = props;
	const params = useParams<{vesselId: string}>();
	const { vesselId } = params;

    useEffect(() => {
        props.loadPortablePumps(vesselId, 1, 100);
        props.loadFlexibleHoses(vesselId, 1, 100);
    	// eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    async function injectScriptAndStyle() {
        if (bookId) {
            console.log('Running Iframe - SealLogsInspectorView...');
            // insert script tag to iframe
            const iframe = iframeRef.current;
            const iframeHeadElem = iframe && iframe.contentDocument.head;
            // if script with id 'pagedjsScript' already exists
            if (
                iframeHeadElem &&
                iframeHeadElem.querySelector('#pagedjsScript')
            ) {
                // delete script tag with id 'pagedjsScript'
                console.log('Deleting pagedjs script tag from iframe...');
                const script = iframeHeadElem.querySelector('#pagedjsScript');
                script?.remove();
            }

            // insert script tag to iframe
            console.log('Inserting pagedjs script tag to iframe...');

            console.log({ iframeHeadElem });

            const script = document.createElement('script');
            script.id = 'pagedjsScript';
            script.src = `/paged.js`;
            // defer
            script.defer = true;
            iframeHeadElem.appendChild(script);

            // run preview script on load
            const script2 = document.createElement('script');
            script2.innerHTML = `window.PagedConfig = {
            auto: false,
        };
        `;

            iframeHeadElem.appendChild(script2);
        }
    }

    useEffect(() => {
        // INFO: Onlcy once user clicks on the YES(show cover pages), the Iframe component gets created.
        // So injection of styles takes place only after user clicks.
        if (stateOfScriptInjection === 'ACTIVE' && showCoverPages) {
            setTimeout(() => {
                injectScriptAndStyle();
            }, 1000);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bookId, stateOfScriptInjection, showCoverPages]);

    // INFO: When user clicks on the "NO" button on print icon click modal, then it moves into state of active & ended
    if (
        stateOfScriptInjection === 'ACTIVE' ||
        stateOfScriptInjection === 'ENDED'
    ) {
        return (
            <Frame
                key={bookId}
                width={'100%'}
                height={'1000px'}
                ref={iframeRef}
                initialContent={getInitialContent(bookId, timeNow)}
                mountTarget="#mountHere"
                id="printIframe"
            >
                <SealLogsView vesselId={vesselId} showCoverPages={showCoverPages} />
            </Frame>
        );
    }

    // INFO: when user clicks "YES" in the modal
    return (
        <div ref={iframeRef}>
            <SealLogsView vesselId={vesselId} showCoverPages={false} />
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
    const inspectorStore = inspectorSelectors._getStore(store);
    const showCoverPages = inspectorSelectors.getShowCoverPages(inspectorStore);
    const stateOfScriptInjection = inspectorSelectors.getStateOfScriptInjection(inspectorStore);
    return {
        showCoverPages,
        stateOfScriptInjection,
    };
}

function mapDispatchToProps(dispatch: Dispatch) {
    return {
        loadPortablePumps(vesselId: string, page: number, limit: number) {
            return dispatch(vesselActions.loadPortablePumps(vesselId, page, limit));
        },
        loadFlexibleHoses(vesselId: string, page: number, limit: number) {
            return dispatch(vesselActions.loadFlexibleHoses(vesselId, page, limit));
        },
    };
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(SealLogsInspectorView);